
export const BRAND_LABEL = 'Brands';
export const STORES_LABEL = 'Stores';
export const MERCHANT_NAME = 'Merchant Name';
export const STORES_DETAILS = 'Store Details';
export const SESSION_TITLE = 'Are You Still There?';
export const SESSION_DES = 'Your session will expire in 60 seconds. Do you want to continue your session?';
export const SESSION_BUTTON = 'Log Out';
export const SESSION_BUTTON2 = 'Stay Logged In';
export const MERCHANT_MISSING_TITLE = 'Account activation pending';
export const MERCHANT_MISSING_DES = 'Your account seem to have not been activated, kindly active your account!!!';
export const MERCHANT_MISSING_BUTTON = 'Log Out';
export const FULL_ADDRESS = 'Full Address';
export const POSTAL_CODE = 'Postal Code';
export const CITY_TEXT = 'City';
export const STATE_TEXT = 'State';
export const COUNTRY_CODE_TEXT = 'Country';
export const LOCATION_TEXT_LATITUDE = 'Location - Latitude';
export const LOCATION_TEXT_LONGITUDE = 'Location - Longitude';
export const DETAILS_TEXT = 'Details';
export const DISCONNECT_TEXT='Disconnect';
export const CONNECT_TEXT = 'Connect';
export const INTER_SUCCESS = 'Successfully Integrated';
export const INTER_SUCCESS_DES = 'Your 7NOW Marketplace integration is complete! Thanks for joining us!';
export const GO_BACK = 'Go Back';
export const IACM_TEXT = 'iacm';
export const INTER_FAILED = 'Integration Error';
export const INTER_FAILED_DES = 'We ran into an error while completing your integration. Please select “Go Back to Submission” to resubmit your location selections.';
export const GO_BACK_SUB = 'Go Back to Submission';
export const ACC_CREATED = 'Account Created — You Did It! 🎉';
export const ACC_CREATED_DES = `Hooray! You've successfully launched another merchant into the 7NOW universe. We've emailed them a temporary password that's good for 7 days, so make sure they log in before it expires—no magic needed, just a timely login!`;
export const ACC_ADMIN_CREATED_DES = `Hooray! You've successfully launched an Admin into the 7NOW universe. We've emailed them a temporary password that's good for 7 days, so make sure they log in before it expires—no magic needed, just a timely login!`;
export const ACC_CREATED_BACK = 'Back to Home';
export const SIGNUP_TEXT = 'dashboard/activation';
export const ADMIN_SIGNUP = 'dashboard/createadmin';
export const ACC_CREATED_BACK_HOME = 'dashboard/adminhomepage';
export const ACC_CREATED_ADMIN = 'Success! 🚀 Account Launched!';
export const ACC_CREATED_BACKHOME_ADMIN = 'Back to Home';
export const SUB_UNSUSS = 'Submission Unsuccessful';
export const SUB_UNSUSS_DES = 'An error occurred while trying to create your account. Please return to the activation screen and re-enter credentials.';
export const CHECK_EMAIL = 'Check your email';
export const CHECK_EMAIL_DES = 'If this email address is associated to an account, we have sent you an email. Check your inbox for instructions on how to reset your password.';
export const CONTINUE_TEXT = 'Continue';
export const CHANGE_PASSWORD_URL = 'changepassword';
export const RESET_PASSWORD_UPDATED = 'Reset Password Successful';
export const RESET_PASSWORD_UPDATED_DESC = 'You have successfully reset your password. Please return to the home screen to login.';
export const RESET_PASSWORD_UPDATED_DESC2 = 'Password updated successfully.';
export const RETURN_TO_LOGIN = 'Back to Login';
export const RESET_PASSWORD_FAILED = 'Reset Password Failed';
export const RESET_PASSWORD_FAILED_DESC = 'Request failed, please try again after sometime';
export const PASSWORD_UPDATED = 'Password Updated';
export const LOGIN_FAILED_ERROR = 'Login Failed, Please try again with valid credentials';
export const LOGIN_FAILED_TIMEOUT = 'Server Timed-out';
export const PASSWORD_OTP_FAILED = 'An error occurred while trying to reset your password due to an incorrect OTP or internal server error. Please try again or request a new OTP.';
export const PASSWORD_UPDATED_DESC = 'Your password has been updated. You can now use your new password to log into merchant portal.';
export const SUB_UNSUSS_DES2 = 'An error occurred while trying to reset your password due to an expired token or internal server error. Please try again or request a new token.';
export const BRANDS_HEADERS = [
	{ key: 'name', label: 'Brand Name', tableOrder: 1 },
	{ key: 'id', label: 'Brand ID', tableOrder: 2 },
	//{ key: 'storescount', label: 'Stores', tableOrder: 3},
	//{ key: 'status-with-inidcation', label: 'Status', tableOrder: 4 },
];
export const BRAND_TABLE_NAME = 'Brands';
export const ALL_BRAND_TABLE_NAME = 'All Brands';
export const BRAND_TABLE_SUBTITLE = 'Select a brand to view the associated stores.';
export const BRAND_SEARCH_PLACEHOLDER = 'Search by Brand ID and Brand Name';
export const STORES_HEADERS = [
	{ key: 'name', label: 'Store Name', tableOrder: 1 },
	{ key: 'id', label: 'Store ID', tableOrder: 2 },
	{ key: 'address.fullAddress', label: 'Address', tableOrder: 3 },
	{ key: 'status-with-inidcation', label: 'Status', tableOrder: 4},
	//{ key: 'action-details', label: 'Action-Details', tableOrder: 5 },
	{ key: 'action-connect', label: 'Action-Connect', tableOrder: 5 }
];

export const STORES_HEADERS_ACCESS = [
	{ key: 'name', label: 'Store Name', tableOrder: 1 },
	{ key: 'id', label: 'Store ID', tableOrder: 2 },
	{ key: 'address.fullAddress', label: 'Address', tableOrder: 3 },
	{ key: 'status-with-inidcation', label: 'Status', tableOrder: 4},
	//{ key: 'action-request', label: 'Action-Request', tableOrder: 5 }
	{ key: 'action-connect', label: 'Action-Connect', tableOrder: 5 }
];
export const STORES_TABLE_NAME = 'Stores';
export const STORES_TABLE_SUBTITLE = 'Select a store to view store details.';
export const STORES_TABLE_SUBTITLE_REQUEST = 'Select a store to view store details. To activate or deactivate a store, please request access.';
export const STORES_SEARCH_PLACEHOLDER = 'Search by Store Name, Store ID and Address';

export const DETAILS_Q1 = 'What is this page for and why is it important?';
export const DETAILS_A1 = 'This page allows the Business Development team to activate merchant accounts for the 7NOW marketplace. It ensures that merchants have the credentials and setup needed to integrate their store systems with the platform, facilitating their onboarding and future transactions.';
export const DETAILS_Q2 = 'Account Activation Process';
export const DETAILS_A2 = `Fill in the merchant's business email, select their aggregator from a dropdown, and enter a chosen username. The system automatically generates and emails a temporary password to the merchant. Then, instruct the merchant to use these credentials to log in, where they will be prompted to set a permanent password and complete their profile setup.`;
export const DETAILS_Q3 = 'Connecting the POS to the Marketplace';
export const DETAILS_A3 = 'The merchant must connect their Point of Sale (POS) system with the marketplace using the credentials provided. This connection allows the merchant’s product listings to be synced with the marketplace, enabling customers to view and purchase their offerings through the 7NOW app.';

export const FETCH_STORE_DETAILS_MSG = 'Fetching Store Details....Please wait!';
export const FETCH_STORE_STATUS_MSG = 'Fetching Store Status....Please wait!';
export const ACTIVATE_STORE_MSG = 'Activating Store....Please wait!';
export const DEACTIAVTE_STORE_MSG = 'De-Activating Store....Please wait!';
export const FETCH_STORE_LIST = 'Fetching Store List....Please wait!';
export const FETCH_BRAND_LIST = 'Fetching Brand List....Please wait!';
export const FETCH_ORG_DETAILS = 'Fetching Organization Details....Please wait!';
export const BRAND_AUTO_SELECTION = 'Auto-selecting... Previous Brand Selection';
export const RENDERING_STORE_LIST = 'Rendering Store list for the Brand';
